import { SCHOOL_QUIZ_API_BASE_URL } from "../../config";
export const getSubjectsNew = `${SCHOOL_QUIZ_API_BASE_URL}/subjects`;
export const getClassesNew = `${SCHOOL_QUIZ_API_BASE_URL}/classes`;
export const quizTypesNew = `${SCHOOL_QUIZ_API_BASE_URL}/get-quiztype`;
